import React from 'react';
import { formatPrice } from '@app/src/utils/normalize';
import {
  Wrapper,
  Igv,
  Price,
  Payment
} from './styled';

interface Props {
  priceTotal?: number;
  bgColor?: string;
  handleClick?: Function;
  className?: string;
}

export const PriceConcept: React.FC<Props> = ({
  priceTotal,
  bgColor,
  handleClick,
  className
}) => (
  <Wrapper
    className={className}
    bgColor={bgColor}
    onClick={e => handleClick && handleClick(e)}
  >
    {
      (priceTotal) ?
        <React.Fragment>
          <Payment>Total a pagar</Payment> <Igv>(Inc. IGV)</Igv>
          <Price>S/ {formatPrice(priceTotal)}</Price>
        </React.Fragment>
      :
        'Las tarifas incluyen IGV.'
    }
  </Wrapper>
);
